import styled from "styled-components";

export const RecentListContainer = styled.div`
  max-width: 1100px;
  margin: 2rem auto;
  padding: 2rem;
`;

export const ListTitle = styled.h3`
  font-weight: 500;
  font-size: 30px;
  padding: 20px 0;
`;
